import * as React from 'react';

function SvgBackToOnboarding(props) {
  return (
    <svg viewBox="0 0 68 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12.666 15.333c0-.736.598-1.333 1.334-1.333h23.333c.736 0 1.334.597 1.334 1.333V20c0 .736-.598 1.333-1.334 1.333H14A1.333 1.333 0 0112.666 20v-4.667zM34 1.333C34 .597 34.597 0 35.333 0H62c.736 0 1.333.597 1.333 1.333V6c0 .736-.597 1.333-1.333 1.333H35.333A1.333 1.333 0 0134 6V1.333zM14.666 45.333h24V50h-24z"
        fill="#F5F5F5"
      />
      <path
        d="M21.334 41.333c0-.736.596-1.333 1.333-1.333h8c.736 0 1.333.597 1.333 1.333V50c0 .736-.597 1.333-1.333 1.333h-8A1.333 1.333 0 0121.333 50v-8.667zM12.667 36.333a6.333 6.333 0 11-12.667 0 6.333 6.333 0 0112.667 0z"
        fill="#F5F5F5"
      />
      <path
        d="M20 26.333a1 1 0 011-1h2.667a1 1 0 010 2H21a1 1 0 01-1-1zM29.667 25.333a1 1 0 100 2h2.666a1 1 0 100-2h-2.666zM29.667 32.667a1 1 0 100 2h2.666a1 1 0 000-2h-2.666zM21 32.667a1 1 0 100 2h2.667a1 1 0 000-2H21zM42 15.667a1 1 0 011-1h2.667a1 1 0 010 2H43a1 1 0 01-1-1zM50.667 15.667a1 1 0 011-1h2.666a1 1 0 110 2h-2.666a1 1 0 01-1-1zM50.667 23a1 1 0 011-1h2.666a1 1 0 110 2h-2.666a1 1 0 01-1-1zM42 23a1 1 0 011-1h2.667a1 1 0 010 2H43a1 1 0 01-1-1z"
        fill="#BFBFBF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34 6c0 .736.597 1.333 1.333 1.333h1.334V14H14c-.736 0-1.333.597-1.333 1.333V20c0 .736.597 1.333 1.333 1.333h.667v28h-7.39A.998.998 0 007.332 49v-6.412a6.335 6.335 0 00-1-12.588 6.333 6.333 0 00-1 12.588V49c0 .117.02.23.057.333H1.667a1 1 0 100 2h40.666a1 1 0 100-2h-3.666v-.666h22V7.333H62c.736 0 1.333-.597 1.333-1.333V1.333C63.333.597 62.736 0 62 0H35.333C34.597 0 34 .597 34 1.333V6zm2-4v3.333h25.333V2H36zm-6 47.333h-6.667V42H30v7.333zm2-8v8h4.667v-28h-20v28h4.666v-8c0-.736.597-1.333 1.334-1.333h8c.736 0 1.333.597 1.333 1.333zm6.667 5.334h20V7.333h-20v39.334zm-2-30.667h-22v3.333h22V16zm-26 20.333a4.333 4.333 0 11-8.667 0 4.333 4.333 0 018.667 0z"
        fill="#BFBFBF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.666 44.333C28.666 55.195 37.472 64 48.334 64 59.195 64 68 55.195 68 44.333c0-10.861-8.805-19.666-19.667-19.666-10.861 0-19.666 8.805-19.666 19.666z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.333 44c0 8.1 6.567 14.667 14.667 14.667S62.666 52.1 62.666 44 56.1 29.333 48 29.333c-8.1 0-14.667 6.567-14.667 14.667z"
        fill="#F5F5F5"
      />
      <path
        d="M48 36v9l5 5"
        stroke="#BFBFBF"
        strokeWidth={3}
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64.84 51.66l1.419.648c4.215-9.463.54-20.6-8.463-25.641l-.751 1.356c8.301 4.645 11.689 14.915 7.796 23.638zm-34.174 1.49c3.383 6.638 10.16 10.823 17.57 10.85a19.7 19.7 0 008.068-1.76l-.633-1.43c-8.833 3.967-19.206.29-23.62-8.376l-1.385.715z"
        fill="#BFBFBF"
      />
    </svg>
  );
}

export default SvgBackToOnboarding;
